const container = document.querySelector('.snowfall-container');
    const numSnowflakes = 15; 
    for (let i = 0; i < numSnowflakes; i++) {
      const snowflake = document.createElement('div');
      snowflake.classList.add('snowflake');
      snowflake.textContent = '❄'; 
      container.appendChild(snowflake);
      const size = Math.random() * 10 + 12; 
      const duration = Math.random() * 5 + 5; 
      const delay = Math.random() * -10; 
      const startX = Math.random() * window.innerWidth; 
      const endX = startX + (Math.random() * 100 - 50); 
      const opacity = Math.random() * 0.5 + 0.5; 
      gsap.set(snowflake, {
        fontSize: size,
        left: startX,
        opacity: opacity,
        color:'lightgray'
      });
      gsap.to(snowflake, {
        y: window.innerHeight + 50, 
        x: endX, 
        duration: duration,
        delay: delay,
        ease: 'none',
        repeat: -1, 
      });
    }